"use client";
import Link from "next/link";
import React from "react";

import { BlogFilterProps } from "@/components/Blog/BlogFilters/types";
import { BLOG_INDEX_URL } from "@/data/helpers/blog/urls";
import { addToSearchParams, encodeParam } from "@/utils/search";
import { useSearchParams } from "next/navigation";
import FilterContainer from "./FilterContainer";
import Label from "./FilterLabel";

const BlogFilterLinks: React.FC<BlogFilterProps> = ({ items, rootPath }) => {
  const searchParams = useSearchParams()?.toString();
  const root = rootPath ?? BLOG_INDEX_URL;

  return (
    <FilterContainer>
      <Link href={`${root}`} className="no-underline">
        <Label>All</Label>
      </Link>
      {items.map(({ label, value }) => (
        <Link
          href={`${root}/?${addToSearchParams(searchParams, {
            category: encodeParam(value),
            page: "", // reset page
          })}`}
          className="no-underline"
          key={value}
        >
          <Label>{label}</Label>
        </Link>
      ))}
    </FilterContainer>
  );
};

export default BlogFilterLinks;
